import AppModal from '@components/AppModal';
import Text from '@components/Text';
import colors from '@constants/colors';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import useCommentInquiry from './hooks/useCommentInquiry';

interface Params {
    inquiryId: string;
    content: string;
    fileUrls: string[];
}

declare module '@stackflow/config' {
    interface Register {
        InquiryCommentModal: Params;
    }
}

const InquiryCommentModal: ActivityComponentType<'InquiryCommentModal'> = ({ params }) => {
    const { t } = useTranslation('inquiry');
    const { inquiryId, content, fileUrls } = params;
    const handleCommentInquiry = useCommentInquiry(inquiryId);
    return (
        <AppModal title={t('comment.confirmTitle')}
            deny={t('comment.cancel')}
            confirm={t('comment.register')}
            onConfirm={() => handleCommentInquiry(content, fileUrls)} >
            <Text color={colors.gray6} align='center'>
                {t('comment.confirmDescription')}
            </Text>
        </AppModal>
    );
};

export default InquiryCommentModal;
